const calculatePercentageString = (num, total) => {
  const percentage = ((num / total) * 100).toFixed(1);
  return percentage.toString().concat('%');
};

export default calculatePercentageString;
